import { render, staticRenderFns } from "./cockpitTagPanel.vue?vue&type=template&id=473de9e1&scoped=true"
import script from "./cockpitTagPanel.vue?vue&type=script&lang=js"
export * from "./cockpitTagPanel.vue?vue&type=script&lang=js"
import style0 from "./cockpitTagPanel.vue?vue&type=style&index=0&id=473de9e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473de9e1",
  null
  
)

export default component.exports